var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgnesisutility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ab1650ce-aeaf-423e-b633-cc8471166d13",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 405.9585 388.9197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a663e69d-8f64-4e56-a85d-fa791c38397c",
    cx: 159.7406,
    cy: 325.2942,
    r: 41.3009,
    gradientTransform: "matrix(1, 0, 0, -1, -12.0415, 461.9432)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3255,
    stopColor: "#ffe380",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6281,
    stopColor: "#ffe482",
    stopOpacity: 0.1795
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7685,
    stopColor: "#ffe58a",
    stopOpacity: 0.2627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8754,
    stopColor: "#ffe996",
    stopOpacity: 0.3261
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9648,
    stopColor: "#ffeea8",
    stopOpacity: 0.3791
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff0b2",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a714cbcc-048a-4962-aa95-cdc990c968c1",
    cx: 159.7406,
    cy: 325.2942,
    r: 28.8023,
    gradientTransform: "matrix(1, 0, 0, -1, -12.0415, 461.9432)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3255,
    stopColor: "#ffe380",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6281,
    stopColor: "#ffe482",
    stopOpacity: 0.3141
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7685,
    stopColor: "#ffe58a",
    stopOpacity: 0.4598
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8754,
    stopColor: "#ffe996",
    stopOpacity: 0.5707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9648,
    stopColor: "#ffeea8",
    stopOpacity: 0.6635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff0b2",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e411969c-ac5b-4979-b663-29d58a37a7a0",
    cx: 159.7406,
    cy: 325.2942,
    r: 15.7241,
    gradientTransform: "matrix(1, 0, 0, -1, -12.0415, 461.9432)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3255,
    stopColor: "#ffe380",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4292,
    stopColor: "#ffe27b",
    stopOpacity: 0.0615
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5534,
    stopColor: "#ffde6c",
    stopOpacity: 0.1351
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6881,
    stopColor: "#ffd854",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8303,
    stopColor: "#ffd032",
    stopOpacity: 0.2993
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9769,
    stopColor: "#ffc607",
    stopOpacity: 0.3863
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc400",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b2e592e7-8a46-412e-9655-72bad902a077",
    cx: 156.0171,
    cy: 317.9676,
    r: 143.9756,
    xlinkHref: "#a663e69d-8f64-4e56-a85d-fa791c38397c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ecd451c8-c347-437a-bbe0-814ffaf40744",
    x1: 70.9585,
    y1: 268.7138,
    x2: 405.9585,
    y2: 268.7138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#deebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acd6bd0b-c498-4ed1-ba23-5a094a5b89c0",
    x1: 264.5967,
    y1: 252.694,
    x2: 292.0989,
    y2: 252.694,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e9ba477f-60ec-495f-9cf7-baec0b3c3801",
    x1: 267.4694,
    y1: 248.6329,
    x2: 272.4574,
    y2: 248.6329,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fbd8864f-3241-4c8d-b6bb-f74f1bce2fa1",
    x1: 262.8037,
    y1: 208.5754,
    x2: 276.6129,
    y2: 208.5754,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a361f491-4d10-43ae-bba4-bfba72ca552c",
    x1: 267.4694,
    y1: 255.1818,
    x2: 272.4574,
    y2: 255.1818,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bbac1274-66e6-4a34-9e32-83279455abeb",
    x1: 262.8037,
    y1: 215.1257,
    x2: 276.6129,
    y2: 215.1257,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e8b07359-9de2-4f4c-b21f-f7aeb346e8d2",
    x1: 267.4694,
    y1: 261.8164,
    x2: 272.4574,
    y2: 261.8164,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a1f7e245-e296-4f46-bf5e-1590137fa74a",
    x1: 262.8037,
    y1: 221.7589,
    x2: 276.6129,
    y2: 221.7589,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e6f61b44-9dbe-4652-b657-a76fbb8cdcb1",
    x1: 130.4118,
    y1: 306.3084,
    x2: 165.9963,
    y2: 306.3084,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b16ed331-fe05-4e36-8396-bd657b397d1c",
    x1: 146.0904,
    y1: 307.7576,
    x2: 152.5396,
    y2: 307.7576,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aea89e5b-86f4-43e8-bce1-41632ebdcddd",
    x1: 342.6927,
    y1: 253.4364,
    x2: 350.58,
    y2: 253.4364,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb80beca-ca12-4fd5-b4c5-3cf773a9036c",
    x1: 328.6334,
    y1: 254.0017,
    x2: 364.6909,
    y2: 254.0017,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a246b7f8-8918-4cb0-a819-56cf71e0f7e5",
    x1: 333.6991,
    y1: 254.0017,
    x2: 359.6252,
    y2: 254.0017,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b29c3a2c-44ea-487e-acf8-acbbfab49d6b",
    x1: 331.1541,
    y1: 316.7807,
    x2: 361.0581,
    y2: 316.7807,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd8de9fc-3e57-49fb-b8a3-09bff0b18394",
    x1: 331.1539,
    y1: 289.3267,
    x2: 361.0583,
    y2: 289.3267,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be5b2b8c-6fca-4c9d-a72d-9832287df306",
    x1: 333.4931,
    y1: 304.2873,
    x2: 338.5392,
    y2: 304.2873,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a0a7fb0b-086f-4597-bb3f-daa88afba9ec",
    x1: 353.5942,
    y1: 304.2873,
    x2: 358.6403,
    y2: 304.2873,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b3629131-bf88-4eab-846b-f7b5e293f6da",
    x1: 343.544,
    y1: 304.2873,
    x2: 348.5901,
    y2: 304.2873,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f4d08687-6670-43c3-a5ca-aba8c825d2a8",
    x1: 260.9421,
    y1: 303.8979,
    x2: 296.4387,
    y2: 303.8979,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b90d8610-cc35-475a-99e2-09780b6f62d7",
    x1: 191.5374,
    y1: 301.3552,
    x2: 225.2318,
    y2: 301.3552,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bcef83d2-1038-41a6-94d5-d984ca6992be",
    x1: 192.1904,
    y1: 253.8057,
    x2: 223.7578,
    y2: 253.8057,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f8b47e8d-3fa4-4bfb-a4f1-fe62d054d58d",
    x1: 120.6224,
    y1: 214.3418,
    x2: 151.97,
    y2: 214.3418,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae9d41cd-8fa9-4f0c-88de-010657c2f027",
    x1: 138.1029,
    y1: 254.1229,
    x2: 162.7817,
    y2: 254.1229,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e5079309-6853-4fce-9a8d-0c7b45a613c4",
    x1: 131.8895,
    y1: 359.4469,
    x2: 160.2608,
    y2: 359.4469,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be6453ff-08dd-4196-99ad-478ba9b56857",
    x1: 189.8828,
    y1: 359.2709,
    x2: 225.2846,
    y2: 359.2709,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2369798-1c47-4055-8172-18c31fb4487b",
    x1: 216.7472,
    y1: 359.2709,
    x2: 221.6782,
    y2: 359.2709,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a219a59c-ae71-428b-8d63-0e3b03ba8125",
    x1: 262.3684,
    y1: 356.6533,
    x2: 277.2167,
    y2: 356.6533,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff341f53-857e-4d25-ae71-d6746dddde38",
    x1: 272.5032,
    y1: 361.0553,
    x2: 287.4917,
    y2: 361.0553,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ef80b582-580a-4b2d-87cc-f9ad0e352652",
    x1: 270.4856,
    y1: 358.934,
    x2: 279.3746,
    y2: 358.934,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd2c8c48-9668-460f-b76e-e94438986d15",
    x1: 330.8379,
    y1: 325.4428,
    x2: 339.324,
    y2: 325.4428,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bdce6476-aa4d-4f24-b884-1c335ca27f5d",
    x1: 330.8379,
    y1: 327.2647,
    x2: 339.324,
    y2: 327.2647,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2bb21ca-3ca5-4e9c-9a52-1916329802c6",
    x1: 342.8802,
    y1: 371.9453,
    x2: 351.372,
    y2: 371.9453,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae16d8e0-61f3-468d-9791-baa610b0f949",
    x1: 339.2091,
    y1: 354.9262,
    x2: 355.0358,
    y2: 354.9262,
    xlinkHref: "#ecd451c8-c347-437a-bbe0-814ffaf40744"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 147.6991,
    cy: 136.6491,
    r: 41.3009,
    style: {
      fill: "url(#a663e69d-8f64-4e56-a85d-fa791c38397c)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.6991,
    cy: 136.6491,
    r: 28.8023,
    style: {
      fill: "url(#a714cbcc-048a-4962-aa95-cdc990c968c1)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.6991,
    cy: 136.6491,
    r: 15.7241,
    style: {
      fill: "url(#e411969c-ac5b-4979-b663-29d58a37a7a0)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.9756,
    cy: 143.9756,
    r: 143.9756,
    style: {
      fill: "url(#b2e592e7-8a46-412e-9655-72bad902a077)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.521,148.5079H399.3962a6.5623,6.5623,0,0,1,6.5623,6.5623V382.3574a6.5623,6.5623,0,0,1-6.5623,6.5623H77.5208a6.5623,6.5623,0,0,1-6.5623-6.5623V155.07A6.5625,6.5625,0,0,1,77.521,148.5079Z",
    style: {
      fill: "url(#ecd451c8-c347-437a-bbe0-814ffaf40744)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4024,171.0648H378.19a5.4722,5.4722,0,0,1,5.4722,5.4722V358.2239a5.4722,5.4722,0,0,1-5.4722,5.4722H98.4022a5.4722,5.4722,0,0,1-5.4722-5.4722V176.5373A5.4724,5.4724,0,0,1,98.4024,171.0648Z",
    style: {
      fill: "#4c9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.4669,236.8091H282.335a4.7822,4.7822,0,0,0-7.8815,0h-3.132v1.5824h-6.7248v32.26h27.5022v-32.26h-6.632Zm-7.0727-.7438a3.4583,3.4583,0,0,1,2.0974.7438h-4.1948A3.4588,3.4588,0,0,1,278.3942,236.0653Zm-5.7434,2.0731h11.4869v3.2686H272.6508Zm18.1189,1.5824v29.6018H265.926V239.7208h5.3955v3.0155h14.1454v-3.0155Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#acd6bd0b-c498-4ed1-ba23-5a094a5b89c0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.4694,251.1272h4.988v-4.9886h-4.988Zm1.3293-3.6594h2.3294v2.33h-2.3294Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#e9ba477f-60ec-495f-9cf7-baec0b3c3801)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.8037,
    y: 207.9108,
    width: 13.8092,
    height: 1.3293,
    style: {
      fill: "url(#fbd8864f-3241-4c8d-b6bb-f74f1bce2fa1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.4694,257.6761h4.988v-4.9886h-4.988Zm1.3293-3.6594h2.3294v2.33h-2.3294Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#a361f491-4d10-43ae-bba4-bfba72ca552c)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.8037,
    y: 214.461,
    width: 13.8092,
    height: 1.3293,
    style: {
      fill: "url(#bbac1274-66e6-4a34-9e32-83279455abeb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.4694,264.3107h4.988v-4.9886h-4.988Zm1.3293-3.6594h2.3294v2.33h-2.3294Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#e8b07359-9de2-4f4c-b21f-f7aeb346e8d2)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.8037,
    y: 221.0943,
    width: 13.8092,
    height: 1.3292,
    style: {
      fill: "url(#a1f7e245-e296-4f46-bf5e-1590137fa74a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.6242,294.8261H130.4118V315.19h3.367v2.601h32.2175V297.4334h-3.3721Zm-30.91,19.0616v-17.76h29.6083v1.3052H133.7788v16.4543Zm32.98,2.6009H135.0808V298.7355h29.6134Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#e6f61b44-9dbe-4652-b657-a76fbb8cdcb1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.9475,311.1622a4.926,4.926,0,0,1-2.4362-.6873l-.4209,1.468a5.2181,5.2181,0,0,0,2.5291.6872v1.5144h1.2817V312.536a2.8467,2.8467,0,0,0,2.6384-2.7795c0-1.39-.7807-2.2328-2.53-2.889-1.3262-.5308-1.8895-.89-1.8895-1.53,0-.5309.39-1.0929,1.4839-1.0929a4.6392,4.6392,0,0,1,2.1234.5308l.4222-1.4368a4.9947,4.9947,0,0,0-2.1553-.515v-1.4527h-1.28v1.53a2.7209,2.7209,0,0,0-2.5138,2.655c0,1.4521,1.0617,2.2016,2.702,2.7954,1.1545.4215,1.7013.8742,1.7013,1.5774C150.6031,310.6777,149.9317,311.1622,148.9475,311.1622Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#b16ed331-fe05-4e36-8396-bd657b397d1c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.4865,252.3472c-1.6237-.6483-2.3107-1.0877-2.3107-1.8706,0-.65.4773-1.3367,1.8141-1.3367a5.69,5.69,0,0,1,2.5969.6483l.5159-1.756a6.1034,6.1034,0,0,0-2.6355-.6312v-1.7761h-1.5658v1.872a3.3268,3.3268,0,0,0-3.0749,3.246c0,1.7761,1.2988,2.6935,3.3039,3.4191,1.4133.5152,2.0817,1.0691,2.0817,1.9292,0,.916-.8215,1.5085-2.0244,1.5085a6.0208,6.0208,0,0,1-2.979-.84l-.516,1.7947a6.3818,6.3818,0,0,0,3.0943.84v1.8534h1.5657V259.28a3.4808,3.4808,0,0,0,3.2273-3.3991C350.58,254.1806,349.6254,253.15,347.4865,252.3472Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#aea89e5b-86f4-43e8-bce1-41632ebdcddd)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.6621,235.9729a18.0288,18.0288,0,1,0,18.0288,18.0288A18.0492,18.0492,0,0,0,346.6621,235.9729Zm0,34.592a16.5632,16.5632,0,1,1,16.5632-16.5632A16.5823,16.5823,0,0,1,346.6621,270.5649Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#bb80beca-ca12-4fd5-b4c5-3cf773a9036c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.6621,241.0394a12.9623,12.9623,0,1,0,12.9631,12.9623A12.9772,12.9772,0,0,0,346.6621,241.0394Zm0,24.4591A11.4968,11.4968,0,1,1,358.16,254.0017,11.5107,11.5107,0,0,1,346.6621,265.4985Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#a246b7f8-8918-4cb0-a819-56cf71e0f7e5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.1541,319.5845h29.904V313.977h-29.904Zm1.3021-4.3055h27.3v3.0034h-27.3Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#b29c3a2c-44ea-487e-acf8-acbbfab49d6b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.0308,294.25a.6519.6519,0,0,0-.2645-.7311l-14.301-9.47a.6476.6476,0,0,0-.7184,0l-14.3009,9.47a.6508.6508,0,0,0,.3592,1.1939h28.6019A.6518.6518,0,0,0,361.0308,294.25Zm-27.0634-.8392,12.1387-8.0387,12.1387,8.0387Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#fd8de9fc-3e57-49fb-b8a3-09bff0b18394)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.5392,312.3075v-16.04h-5.0461v16.04Zm-3.744-14.7384h2.442v13.4363h-2.442Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#be5b2b8c-6fca-4c9d-a72d-9832287df306)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.64,312.3075v-16.04h-5.0461v16.04Zm-3.7441-14.7384h2.442v13.4363h-2.442Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#a0a7fb0b-086f-4597-bb3f-daa88afba9ec)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.59,312.3075v-16.04H343.544v16.04Zm-3.7441-14.7384h2.442v13.4363h-2.442Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#b3629131-bf88-4eab-846b-f7b5e293f6da)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.4374,301.2858c-.0025-1.0686-1.1394-1.9235-3.4676-2.6026a1.4163,1.4163,0,0,0,.1784-.6512h.0063v-5.6036c0-3.1628-10.5355-3.9974-16.1062-3.9974s-16.1062.8346-16.1062,3.9974v5.601a1.8985,1.8985,0,0,0,.9624,1.5075,8.73,8.73,0,0,0,2.5027,1.0964,1.4432,1.4432,0,0,0-.1745.6525h-.0076v5.601a1.3658,1.3658,0,0,0,.1011.4768c-1.8653.64-2.81,1.4454-2.8112,2.399H261.51v5.6022h-.0012c0,3.1628,10.533,4,16.1036,4,5.5682,0,16.0974-.8372,16.1024-3.9975h.0076v-5.6047h-.0012a1.3914,1.3914,0,0,0-.0975-.4831c1.6883-.5868,2.8063-1.3645,2.8075-2.39h.0076v-5.6035Zm-19.3891-11.5535c9.5783,0,14.8049,1.7806,14.8049,2.6961s-5.2266,2.6962-14.8049,2.6962-14.8036-1.7806-14.8036-2.6962S267.47,289.7323,277.0483,289.7323Zm-14.8036,8.3V294.14a18.569,18.569,0,0,0,6.3256,1.7325v.0177h.0291v-.0139a65.17,65.17,0,0,0,16.89.0012v.0127h.0316l-.0012-.0164a18.6162,18.6162,0,0,0,6.3332-1.7338v3.89h-.0063c0,.9156-5.2254,2.6975-14.8024,2.6975C267.4739,300.7269,262.251,298.9475,262.2447,298.032Zm3.0047,10.4078c2.78,1.8969,10.5608,2.447,15.0781,2.447a54.3816,54.3816,0,0,0,12.0429-1.2343.2974.2974,0,0,1,.0481.1113c0,.2631-1.0888,1.3974-6.4483,2.1625a59.708,59.708,0,0,1-8.3528.5362,60.4735,60.4735,0,0,1-8.3819-.5362c-5.3291-.7651-6.4192-1.8994-6.4192-2.1625C262.8163,309.602,263.288,309.0278,265.2494,308.44Zm27.17,6.925h-.0064c0,.9143-5.2241,2.6975-14.8011,2.6975-9.5693,0-14.7922-1.7794-14.8011-2.695v-3.8836a18.15,18.15,0,0,0,6.2675,1.7313l.0581.0076v.0012h.014a66.7413,66.7413,0,0,0,17.0344-.0088,18.0572,18.0572,0,0,0,6.2346-1.7275Zm2.7164-8.478H295.13c0,.9156-5.2254,2.6987-14.8023,2.6987-9.5707,0-14.7935-1.7806-14.8-2.6962v-3.8836a18.1783,18.1783,0,0,0,6.2725,1.7351c.0165.0025.0355.0038.0531.0063,1.2862.1783,2.6608.3136,4.0873.4047s2.9048.1378,4.3946.1378a63.3837,63.3837,0,0,0,8.5374-.5488,18.2146,18.2146,0,0,0,6.2637-1.7313Zm-6.4458-3.436a66.56,66.56,0,0,1-16.7094,0c-5.3531-.765-6.447-1.8994-6.447-2.1612,0-.0493.0518-.1581.2188-.3073a57.68,57.68,0,0,0,11.2917,1.0459c4.3895,0,11.8419-.5236,14.8113-2.2915,2.6544.66,3.28,1.3556,3.28,1.5529C295.1362,301.5514,294.041,302.6858,288.69,303.4508Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#f4d08687-6670-43c3-a5ca-aba8c825d2a8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.7794,284.5289l-3.9292,3.9625a15.7756,15.7756,0,0,0-8.2978-2.34,16.0324,16.0324,0,1,0,13.6939,7.7236l3.9855-4.02-4.5992-.6243Zm-12.227,32.35a14.7129,14.7129,0,1,1,0-29.4258,14.5,14.5,0,0,1,7.4155,2.0221l.8207,3.5339-1.11,1.11a10.8066,10.8066,0,1,0,.92.9206L216.69,293.95l3.5911.8459a14.7063,14.7063,0,0,1-12.7285,22.0839Zm3.456-14.7129a3.4607,3.4607,0,1,1-1.5176-2.859l-2.3987,2.3987.9206.9206,2.3987-2.3988A3.436,3.436,0,0,1,211.0084,302.1664Zm-.5976-3.779a4.712,4.712,0,0,0-2.8584-.9791,4.7581,4.7581,0,1,0,4.758,4.7581,4.7117,4.7117,0,0,0-.979-2.8584l3.3476-3.3477a9.4952,9.4952,0,1,1-.9206-.9205Zm9.5009-5.0162-2.8584-.6739-.6714-2.8915,2.5634-2.5863.576,3.1738,2.9462.4Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#b90d8610-cc35-475a-99e2-09780b6f62d7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.7578,253.8057a15.7837,15.7837,0,1,0-15.7837,15.7837A15.8015,15.8015,0,0,0,223.7578,253.8057Zm-2.5866,5.9752-12.0194-5.4671,11.8547-6.8247a14.3331,14.3331,0,0,1,.1647,12.2918Zm-.7762-13.419-12.3219,7.0929-8.746-11.2618a14.4334,14.4334,0,0,1,21.0679,4.1689Zm-26.9215,7.4438a14.4522,14.4522,0,0,1,4.86-10.8014l9.4112,12.1195.0394-.0226,12.8072,5.8254a14.4915,14.4915,0,0,1-27.1179-7.1209Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#bcef83d2-1038-41a6-94d5-d984ca6992be)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.746 198.679 120.622 198.679 120.622 230.005 151.97 230.005 151.97 228.881 121.746 228.881 121.746 198.679",
    style: {
      fill: "url(#f8b47e8d-3fa4-4bfb-a4f1-fe62d054d58d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.3311,264.2151a2.2269,2.2269,0,0,0,1.8481-3.4714l6.131-6.8923a2.2009,2.2009,0,0,0,1.0086.2526,2.2244,2.2244,0,0,0,2.1794-2.6883l7.388-3.6942a2.1938,2.1938,0,1,0-.5113-1l-7.3874,3.6939a2.2218,2.2218,0,0,0-3.5217,2.6952l-6.135,6.8967a2.2007,2.2007,0,0,0-1-.2477,2.228,2.228,0,1,0,0,4.456Zm20.2223-19.0609a1.1045,1.1045,0,1,1-1.1048,1.1042A1.1055,1.1055,0,0,1,160.5534,245.1542Zm-11.2346,5.6173a1.1045,1.1045,0,1,1-1.1048,1.1042A1.1055,1.1055,0,0,1,149.3188,250.7715Zm-8.9877,10.1111a1.1046,1.1046,0,1,1-1.1048,1.1043A1.1056,1.1056,0,0,1,140.3311,260.8826Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#ae9d41cd-8fa9-4f0c-88de-010657c2f027)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.3344,350.4132H150.12V372.55h-.9816v-27.22h-6.2141v27.22h-.8787V355.808h-6.2141V372.55H131.89v1.0133h28.3713V372.55h-3.9264Zm-5.2009,1.0132h4.1876V372.55h-4.1876Zm-7.1957-5.0826h4.1876V372.55h-4.1876Zm-7.0929,10.4774h4.1877V372.55h-4.1877Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#e5079309-6853-4fce-9a8d-0c7b45a613c4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.6617,344.6743h-28.156a3.6268,3.6268,0,0,0-3.6229,3.6229v21.9473a3.6268,3.6268,0,0,0,3.6229,3.6229h28.156a3.6268,3.6268,0,0,0,3.6229-3.6229V348.2972A3.6268,3.6268,0,0,0,221.6617,344.6743Zm0,27.89h-28.156a2.3227,2.3227,0,0,1-2.32-2.32V348.2972a2.3227,2.3227,0,0,1,2.32-2.32h28.156a2.3228,2.3228,0,0,1,2.32,2.32v6.2959h-4.5786a4.7,4.7,0,0,0-4.6651,4.6778,4.6771,4.6771,0,0,0,4.6651,4.6778h4.5786v6.2958A2.3228,2.3228,0,0,1,221.6617,372.5643Zm2.32-16.6682v6.75h-4.5786a3.3658,3.3658,0,0,1-2.3669-5.755,3.3318,3.3318,0,0,1,2.3669-.9945Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#be6453ff-08dd-4196-99ad-478ba9b56857)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.7472,359.2709a2.4655,2.4655,0,1,0,2.4648-2.4655A2.4679,2.4679,0,0,0,216.7472,359.2709Zm3.6279,0a1.1625,1.1625,0,1,1-1.1631-1.1625A1.1642,1.1642,0,0,1,220.3751,359.2709Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#b2369798-1c47-4055-8172-18c31fb4487b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.483,351.874a10.1588,10.1588,0,0,1,3.5974-2.11l.2525,1.8254,5.8838-4.5761-6.905-2.8074.2551,1.8441a13.473,13.473,0,0,0-5.2171,3.8212,12.7908,12.7908,0,0,0-2.9326,7.1453,12.3457,12.3457,0,0,0,1.6128,7.2541,12.014,12.014,0,0,0,5.2647,4.8292,11.524,11.524,0,0,1-4.3914-5.2632,10.8776,10.8776,0,0,1-.5562-6.5375A10.345,10.345,0,0,1,267.483,351.874Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#a219a59c-ae71-428b-8d63-0e3b03ba8125)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.7777,353.3439a12.0021,12.0021,0,0,0-5.543-4.8951,11.5112,11.5112,0,0,1,4.6741,5.3381,10.8624,10.8624,0,0,1,.5907,6.7657,10.4133,10.4133,0,0,1-3.3586,5.5506,10.1551,10.1551,0,0,1-3.5263,1.9512l-.256-1.77-5.8554,4.6123,6.922,2.7648-.2846-1.9684a13.4518,13.4518,0,0,0,5.0648-3.5169,12.8583,12.8583,0,0,0,3.2205-7.3184A12.33,12.33,0,0,0,285.7777,353.3439Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#ff341f53-857e-4d25-ae71-d6746dddde38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.3746,358.934A4.4445,4.4445,0,1,1,274.93,354.49,4.4445,4.4445,0,0,1,279.3746,358.934Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#ef80b582-580a-4b2d-87cc-f9ad0e352652)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.8379,
    y: 324.8584,
    width: 8.4861,
    height: 1.1689,
    style: {
      fill: "url(#fd2c8c48-9668-460f-b76e-e94438986d15)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.8379,
    y: 326.6802,
    width: 8.4861,
    height: 1.1689,
    style: {
      fill: "url(#bdce6476-aa4d-4f24-b884-1c335ca27f5d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.88,368.5843v2.268a4.2508,4.2508,0,1,0,8.4918,0v-2.268Zm7.3235,2.268a3.0838,3.0838,0,1,1-6.1545,0v-1.1h6.1545Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#b2bb21ca-3ca5-4e9c-9a52-1916329802c6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.1221,345.6768a7.9282,7.9282,0,0,0-7.913,7.9244,7.6585,7.6585,0,0,0,.7249,3.291l-.0067.0026,3.0282,7.2809h8.2572l3.0589-7.1688.0867-.0847v-.1287a7.66,7.66,0,0,0,.6775-3.1923A7.9284,7.9284,0,0,0,347.1221,345.6768Zm6.1245,10.7359-.008.036-2.7975,6.5579h-6.7047l-2.7294-6.5619-.0014.0007-.0073-.0327a6.51,6.51,0,0,1-.62-2.8115,6.7444,6.7444,0,1,1,13.4887,0A6.51,6.51,0,0,1,353.2466,356.4127Z",
    transform: "translate(-12.0415 -40.0568)",
    style: {
      fill: "url(#ae16d8e0-61f3-468d-9791-baa610b0f949)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.781 135.162 155.761 190.488 211.483 118.42 183.056 121.833 247.688 37.943 204.481 38.112 147.891 137.805 176.781 135.162",
    style: {
      fill: "#ffc400"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgnesisutility);
export default __webpack_public_path__ + "static/media/ignesisutility.13eaa531ee4377e7b6a110c6540ffa15.svg";
export { ForwardRef as ReactComponent };